<template>
  <smd-one-col-layout class="modal-watsons-branch">
    <full-screen-loader position="fixed" v-if="isLoading"/>
    <div class="smd-header smd-form__row m-b-10"
         slot="header">
      <span class="ns-icon-ico028"
            @click="handleWatsonBranchNoSelection"/>
      <text-string class="modal-watsons-branch__header-title"
                   :label-id="isBranchForPickup ? 'txt289' : 'txt134'"/>
      <span class="ns-icon-ico001">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </div>

    <template slot="toolbar">
      <div class="smd-form__row justify-content-center">
        <img src="../assets/images/img004.png" width="136.53" alt="watsons logo">
      </div>
      <smd-search class="m-t-15"
                  custom-placeholder="Search by address or branch name"

                  v-model="search"/>
    </template>

    <smd-branch v-for="branch in filteredBranch"
                :address="branch.address"
                :contactNumbers="branch.mobilenumbers"
                :days="splitDaysAndHours(branch.officeHours, 0)"
                :hours="splitDaysAndHours(branch.officeHours, 1)"
                :item="branch"
                :is-selected="isSelectedBranch(branch.branchCode)"
                :key="branch.id"
                :name="branch.branchName"
                @selected="handleSelectedBranch"/>

    <div class="modal-watson-branch__footer"
         slot="bottom-nav">
      <smd-btn :section="$isDesktop ? '4' : '1'"
               :variant="computedBtnVariant"
               @click="handleWatsonBranchSelection">
        {{ computedBtnText }}
      </smd-btn>
    </div>

    <div class="branch-pickup-terms-toast" v-show="isBranchForPickup && selectedBranch">
      <text-string ref="showTerms"
                   label-id="txt338"
                   :props="{functions: {$1: '#'}}"
                   @handleClick="showTerms"/>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import {ACTION_SET_WATSONS_BRANCH, GETTER_GET_WATSONS_BRANCH} from "@/store/types";
  import {WatsonsBranchService} from "@/services/partner";

  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import GetElementString from '@/mixins/get-element-string';
  import Logo from '@/assets/images/now-serving-heart.svg';
  import ModalWatsonsTersmAndConditions from '@/modals/modal-watsons-terms-and-conditions';
  import {Reference} from "smd-vue-scaffold";

  export default {
    name: "modal-watsons-branch",
    mixins: [CloseModalMixin, GetElementString],
    props: {
      existingSelectedWatsonBranch: {type: Object},
      cityName: {type: String, default: ''},
      isBranchForPickup: {type: Boolean, default: false}
    },
    data() {
      return {
        selectedBranch: null,
        search: '',
        isLoading: true,
        isTermsChecked: true,
      }
    },
    computed: {
      ...mapGetters({
        watsonsBranchList: GETTER_GET_WATSONS_BRANCH
      }),
      computedBtnText() {
        return this.selectedBranch ? `Choose ${this.selectedBranch.branchName}` : 'Select';
      },
      computedBtnVariant() {
        return this.$isDesktop ? (this.selectedBranch && this.isTermsChecked ? 'blue-enabled' : 'blue-disabled') : (this.selectedBranch && this.isTermsChecked ? 'enabled-blue' : 'disabled');
      },
      filteredBranch() {
        return this.watsonsBranchList.filter(branch => {
          return branch.branchName.toLowerCase().includes(this.search.toLowerCase());
        })
      }
    },
    methods: {
      ...mapActions({
        setWatsonBranches: ACTION_SET_WATSONS_BRANCH
      }),
      async getWatsonBranchList() {
        try {
          const splitCity = this.cityName.split(',');
          const {data} = await WatsonsBranchService.getWatsonsBranch(splitCity[0]);
          this.setWatsonBranches(data);
          this.isLoading = false;
        } catch (error) {
          console.log(error)
        }
      },
      handleSelectedBranch(val) {
        this.selectedBranch = val
      },
      handleWatsonBranchNoSelection() {
        this.$modal.close(this.existingSelectedWatsonBranch);
      },
      handleWatsonBranchSelection() {
        if (this.selectedBranch && this.isTermsChecked) {
          this.$modal.close(this.selectedBranch);
        }
      },

      isSelectedBranch(val) {
        return this.selectedBranch !== null ? val === this.selectedBranch.branchCode : null
      },
      splitDaysAndHours(val, indexToGet) {
        const split = val.split('|')

        return split[indexToGet];
      },
      showTerms() {
        this.$modal.open({
          component: ModalWatsonsTersmAndConditions,
          size: this.$isMobile ? Reference.SmdModalSizes.xs : Reference.SmdModalSizes.md,
          props: {
            termsAccepted: this.isTermsChecked
          },
          onClose: ({checked}) => {
            this.isTermsChecked = checked
          }
        })
      }
    },
    mounted() {
      this.getWatsonBranchList();
    },
    created() {
      if (this.existingSelectedWatsonBranch)
        this.selectedBranch = this.existingSelectedWatsonBranch;
    },
    Logo
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .modal-watsons-branch {
    .branch-pickup-terms-toast {
      @extend %layout--flex-center-xy;
      @include responsive(desktop) {
        bottom: 80px;
      }
      position: fixed;
      bottom: 55px;
      left: 0;
      width: 98.9%;

      > div {
        @include border-radius(radius(small));
        text-align: center;
        background: color(disabled, background);
        padding: space(s);
        margin: 0 20px;
      }
    }
  }

  .modal-watsons-branch__header-title {
    flex: 1;
    text-align: center;
  }

  .modal-watson-branch__footer {
    @include responsive(desktop) {
      display: flex;
      justify-content: center;
      padding: space(base);
    }
  }
</style>